// add class nMerchandising to an Item Merchandising widget to move all
// the product tiles into a new container which we can then use with Splide
$(document).ready(() => {
  $('.nMerchandising').prepend('<div class="nCarousel splide"><div class="splide__track"><div class="splide__list"></div></div></div>');
  $('.nMerchandising .owl-item:not(.cloned)').each(function () {
    $(this).addClass('splide__slide');
    $(this).closest('.nMerchandising').find('.splide__list').append(this);
  });
  // hiding the remainder of the carousel with cloned items
  $('.nMerchandising > section.merchandising-carousel').css('display', 'none');

  $('.nMerchandising').wrapInner('<div class="container"></div>');
  // uncomment the section below to use the widget title if the carousel needs to have title
  $('.nMerchandising .merchandising-carousel h3').each(function () {
    $(this).closest('.nMerchandising').find('.nCarousel').before(this);
  });
});

(() => {
  const merchandisingButtons = document.querySelectorAll('.buttons.group');

  const loginForPricing = document.createElement('button');
  loginForPricing.classList.add('primary', 'btn-custom', 'js-login-toggle');
  loginForPricing.innerHTML = 'Login To See Pricing';

  merchandisingButtons.forEach((button) => {
    button.insertAdjacentElement('afterend', loginForPricing.cloneNode(true));
  });
})();
